import styled from "styled-components";

export const Wrapper = styled("footer")(({ theme }) => ({
  backgroundColor: theme.palette.footerBg,
  backgroundImage: 'url("/images/design/footer-bg.png")',
  backgroundRepeat: "no-repeat",
  backgroundSize: "cover",
  backgroundPosition: "center",
  color: theme.palette.white,
  flexShrink: 0,
  paddingTop: 30,
}));
